export enum AnswerType {
  Text = 'text',
  Image = 'image',
}
